import script from "./BalanceOverview.vue?vue&type=script&lang=ts&setup=true"
export * from "./BalanceOverview.vue?vue&type=script&lang=ts&setup=true"

import "./BalanceOverview.vue?vue&type=style&index=0&id=3fdd0d20&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fdd0d20"]])

export default __exports__